
async function getSegmentMap() {
  const cxid = window.Eacs.cxid;
  if (!cxid) {
    return;
  }
  
  window.Eacs.Segment.Map = await fetch(
    `/a/eacs/sh-app/promos/promo-segments-details?cxid=${cxid}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  ).then(function (res) {
    return res.json();
  });

}
async function segmentedBadgeMechanicsInsert() {
  const divBadges = document.getElementsByClassName("eacs-badge");
  for (const divBadge of divBadges) {
    JSON.parse(divBadge.dataset.eacsSegmentBadges);
    let badgesDetails;
    if (!divBadge?.dataset?.eacsSegmentBadges) {
      continue;
    }
    if (
      typeof divBadge.dataset.eacsSegmentBadges === "string" &&
      divBadge.dataset.eacsSegmentBadges.trim()
    ) {
      badgesDetails = JSON.parse(divBadge.dataset.eacsSegmentBadges);
    } else {
      badgesDetails = divBadge.dataset.eacsSegmentBadges;
    }
    if (Array.isArray(badgesDetails) && badgesDetails.length > 1) {
      badgesDetails.shift();
    } else {
      continue;
    }

    for (const bDetails of badgesDetails) {
      const promo = window.Eacs.Segment.Map[bDetails.p];
      if (!promo) continue;
      const badgeTag = divBadge.firstElementChild;
      if (
        badgeTag?.dataset?.eacsBadgePriority === null ||
        badgeTag?.dataset?.eacsBadgePriority === undefined ||
        Number(badgeTag?.dataset?.eacsBadgePriority) >= bDetails.pr
      ) {
        divBadge.innerHTML = `<h6 class="product-badge--${promo.color}" data-eacs-badge-priority="${bDetails.pr}">${promo.badge}</h6>`;
      }
    }
  }

  for (const mDetails of window.Eacs.Segment.Mechanics) {
    const mechanicsContainers =
      document.getElementsByClassName("promo-placeholder");
    const promo = window.Eacs.Segment.Map[mDetails.p];
    if (!promo) continue;
    for (const mechanicsContainer of mechanicsContainers) {
      if (mechanicsContainer?.tagName?.toLowerCase() !== "ul") continue;
      const li = document.createElement("li");
      li.innerHTML = promo.mechanics;
      if (promo.mechanics) mechanicsContainer.appendChild(li);
    }
  }
}
segmentMap = getSegmentMap();

document.addEventListener("DOMContentLoaded",async function () {
  await segmentMap
  segmentedBadgeMechanicsInsert();
});